import { oneliveAssets } from './assets';
import type { OneliveSessionUser } from './api';

export type MemberLevelId = 2 | 3 | 4 | 5 | 6 | 8 | 9;

export type MemberLevelMeta = {
  level: MemberLevelId;
  label: string;
  icon: string;
  tone: string;
};

const BASE = '/assets/templates/onelive-basic/ftv';
const LEVEL_ICON = `${BASE}/hall-of-fame.svg`;

const LEVEL_TABLE: Record<number, Omit<MemberLevelMeta, 'level'>> = {
  2: { label: '일반회원', icon: LEVEL_ICON, tone: '#8e9299' },
  3: { label: '실버회원', icon: LEVEL_ICON, tone: '#9aa3ad' },
  4: { label: '골드회원', icon: LEVEL_ICON, tone: '#d4a017' },
  5: { label: '다이아몬드', icon: LEVEL_ICON, tone: '#e2284b' },
  6: { label: 'VIP', icon: LEVEL_ICON, tone: '#7b4fd6' },
  8: { label: '운영자', icon: LEVEL_ICON, tone: '#222222' },
  9: { label: '관리자', icon: LEVEL_ICON, tone: '#444444' },
};

export function resolveMemberLevel(
  level?: number | null,
  label?: string | null,
  user?: Pick<OneliveSessionUser, 'is_admin' | 'is_super' | 'member_level' | 'member_level_label'> | null,
): MemberLevelMeta {
  if (user?.is_super) {
    const row = LEVEL_TABLE[9];
    return { level: 9, label: (label || '').trim() || row.label, icon: row.icon, tone: row.tone };
  }
  if (user?.is_admin) {
    const row = LEVEL_TABLE[9];
    return { level: 9, label: (label || '').trim() || '관리자', icon: row.icon, tone: row.tone };
  }

  const normalized = Number(level ?? user?.member_level);
  const row = LEVEL_TABLE[normalized] ?? LEVEL_TABLE[2];
  const resolvedLabel = (label || user?.member_level_label || '').trim() || row.label;

  return {
    level: (LEVEL_TABLE[normalized] ? normalized : 2) as MemberLevelId,
    label: resolvedLabel,
    icon: row.icon,
    tone: row.tone,
  };
}

export const DRAWER_QUICK_LINKS = [
  { label: '마이페이지', path: '/mypage/profile', icon: oneliveAssets.drawerMypage, lineIcon: true },
  { label: '아이템샵', path: '/shop', icon: oneliveAssets.drawerItem, lineIcon: true },
  { label: '쪽지함', path: '/mypage/messages', icon: oneliveAssets.drawerMessage, countKey: 'messages' as const },
];
